import axios from 'axios'

import config from '../../config.client.js'
import queryString from 'query-string'

const url = config.apiUrl

export default {
  getWopi360Target: uuid => {
    return axios.get(url + `targets/${uuid}`)
  },

  getWopi360TargetDetails: uuid => {
    return axios.get(url + `targets/${uuid}/details`)
  },

  searchWopi360Targets: ({ organisationId, unitUuid, keyword, filters, page, smallLimit }) => {
    const filterQuery = {
      keyword,
      page,
      status: filters ? filters.status : undefined,
      'unit-uuid': unitUuid,
      'small-limit': smallLimit
    }

    return axios.get(
      url + `organisations/${organisationId}/targets?${queryString.stringify(filterQuery)}`
    )
  },

  createWopi360Target: (
    organisationId,
    givenName,
    familyName,
    email,
    organisationName,
    role,
    deadlineAt,
    language,
    isManager,
    canInvite,
    message,
    unitUuids
  ) => {
    return axios.post(url + `organisations/${organisationId}/targets`, {
      givenName,
      familyName,
      email,
      organisation: organisationName,
      role,
      deadlineAt: deadlineAt
        .locale(language)
        .endOf('day')
        .format('YYYY-MM-DD HH:mm:ss.SSS ZZ'),
      language,
      isManager,
      canInvite,
      message,
      unitUuids
    })
  },

  editWopi360Target: (
    organisationId,
    uuid,
    givenName,
    familyName,
    email,
    organisationName,
    role,
    deadlineAt,
    language,
    unitUuids
  ) => {
    return axios.patch(url + `organisations/${organisationId}/targets/${uuid}`, {
      givenName,
      familyName,
      email,
      organisation: organisationName,
      role,
      deadlineAt: deadlineAt
        .locale(language)
        .endOf('day')
        .format('YYYY-MM-DD HH:mm:ss.SSS ZZ'),
      language,
      unitUuids
    })
  },

  sendWopi360Invitations: (uuid, language, recipients, message, manager) => {
    return axios.post(url + `targets/${uuid}/invitations`, {
      language,
      recipients,
      message,
      manager
    })
  },

  closeWopi360Target: uuid => {
    return axios.patch(url + `targets/${uuid}/close`, {})
  },

  deleteWopi360Target: (organisationId, uuid) => {
    return axios.delete(url + `organisations/${organisationId}/targets/${uuid}`)
  },

  getWopi360: uuid => {
    return axios.get(url + `wopi360/${uuid}`)
  },

  getTranslationsForWopi360Questions: language => {
    return axios.get(url + `translations/${language}/wopi360`)
  },

  startWopi360: uuid => {
    return axios.patch(url + `wopi360/${uuid}/start`, {})
  },

  selectWopi360Role: (uuid, role) => {
    return axios.patch(url + `wopi360/${uuid}/role`, {
      role
    })
  },

  answerWopi360Questions: (uuid, answers, activeQuestionIndex) => {
    return axios.patch(url + `wopi360/${uuid}/answers`, {
      answers: answers,
      activeQuestionIndex: activeQuestionIndex
    })
  },

  answerWopi360OpenQuestions: (uuid, openAnswers) => {
    return axios.patch(url + `wopi360/${uuid}/open-answers`, {
      openAnswers
    })
  },

  deleteWopi360: (organisationId, targetUuid, wopi360Uuid) => {
    return axios.delete(
      url + `organisations/${organisationId}/targets/${targetUuid}/invitations/${wopi360Uuid}`
    )
  },

  sendWopi360ReminderMails: (organisationId, targetUuid, wopi360Uuids) => {
    return axios.post(
      url + `organisations/${organisationId}/targets/${targetUuid}/invitations/sendReminders`,
      { uuids: wopi360Uuids }
    )
  }
}



// WEBPACK FOOTER //
// ./src/services/wopi360.js